import { CountryIso2Code } from './constants.ts'

const EU_COUNTRIES_ISO2_CODES = new Set<CountryIso2Code>([
  CountryIso2Code.AT,
  CountryIso2Code.BE,
  CountryIso2Code.BG,
  CountryIso2Code.CY,
  CountryIso2Code.CZ,
  CountryIso2Code.DE,
  CountryIso2Code.DK,
  CountryIso2Code.EE,
  CountryIso2Code.ES,
  CountryIso2Code.FI,
  CountryIso2Code.FR,
  CountryIso2Code.GR,
  CountryIso2Code.HR,
  CountryIso2Code.HU,
  CountryIso2Code.IE,
  CountryIso2Code.IT,
  CountryIso2Code.LT,
  CountryIso2Code.LU,
  CountryIso2Code.LV,
  CountryIso2Code.MT,
  CountryIso2Code.NL,
  CountryIso2Code.PL,
  CountryIso2Code.PT,
  CountryIso2Code.RO,
  CountryIso2Code.SE,
  CountryIso2Code.SI,
  CountryIso2Code.SK,
])

export function isInEu(countryCode: CountryIso2Code): boolean {
  return EU_COUNTRIES_ISO2_CODES.has(countryCode)
}
